/* Header that hides when the page is scrolled down and comes back when it is scrolled up. It always shows at the top of the page,
   and while the focus or the pointer is inside it. */
(() => {
  const header = document.querySelector('.header');
  if (!header) return;

  const wrapper = header.parentElement;
  const threshold = 8;
  let last = window.scrollY;
  let frame = 0;

  const holdPlace = () => {
    if (header.dataset.variant === 'overlay') return;
    wrapper.style.minHeight = header.offsetHeight + 'px';
  };

  header.setAttribute('data-sticky', '');
  holdPlace();
  if ('ResizeObserver' in window) new ResizeObserver(holdPlace).observe(header);
  else window.addEventListener('resize', holdPlace);

  const show = () => header.removeAttribute('data-hidden');
  const hide = () => header.setAttribute('data-hidden', '');

  const update = () => {
    frame = 0;
    const y = window.scrollY;
    const delta = y - last;
    if (y <= header.offsetHeight) {
      show();
    } else if (Math.abs(delta) >= threshold) {
      if (delta < 0 || header.contains(document.activeElement) || header.matches(':hover')) show();
      else hide();
    } else {
      return;
    }
    last = y;
  };

  window.addEventListener('scroll', () => {
    if (!frame) frame = requestAnimationFrame(update);
  }, { passive: true });

  header.addEventListener('focusin', show);
})();
